import { useLocation } from 'react-router-dom';
import { RoutesConfig } from 'navigation/routes';

// True when the shared configurator is being used inside the quotation flow.
// Route-based on purpose: the config form is shared with the order flow, and
// this lets us gate quotation-only UI (e.g. the "indicative" checkbox) without
// introducing the quotationInfo slice yet. Mirrors the pathname checks already
// used in ProductForm.
export const useIsQuotationMode = (): boolean => {
  const location = useLocation();
  return location.pathname.includes(RoutesConfig.BuyerNewQuotation.fullPath);
};
